import { ArrowRight } from "lucide-react";

const STANDARD_LENGTHS = [
  { label: "8\"", sub: "Pixie" },
  { label: "10\"", sub: "Bob" },
  { label: "12\"", sub: "Chin" },
  { label: "14\"", sub: "Shoulder" },
  { label: "16\"", sub: "Collar" },
  { label: "18\"", sub: "Bust" },
  { label: "20\"", sub: "Mid-back" },
  { label: "22\"", sub: "Waist" },
  { label: "24\"", sub: "Long" },
  { label: "26\"", sub: "Extra long" },
  { label: "28\"", sub: "Floor" },
  { label: "30\"", sub: "Statement" },
];

const ShopByLength = ({ onSelect, available = [] }) => {
  const availSet = new Set(available.map((l) => l.value));
  const countBy = Object.fromEntries(available.map((l) => [l.value, l.count]));

  return (
    <section
      id="shop-by-length"
      data-testid="shop-by-length"
      className="border-b border-border/60 bg-secondary/30"
    >
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-14 lg:py-20">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-[#B8935F] font-medium mb-2">
              By the inch
            </div>
            <h2 className="font-serif text-4xl lg:text-5xl leading-tight text-foreground">
              Shop by length
            </h2>
            <p className="text-muted-foreground mt-2 text-sm max-w-lg">
              From bold pixies to floor-grazing statement pieces. Tap a length
              to filter.
            </p>
          </div>
          <a
            href="#catalog"
            className="text-sm text-foreground/80 hover:text-[hsl(var(--primary))] link-underline inline-flex items-center gap-1"
          >
            View all <ArrowRight className="w-3.5 h-3.5" />
          </a>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-3 lg:gap-4">
          {STANDARD_LENGTHS.map((l) => {
            const count = countBy[l.label] || 0;
            const inStock = count > 0;
            return (
              <button
                key={l.label}
                data-testid={`shop-length-${l.label}`}
                onClick={() => onSelect(l.label)}
                title={inStock ? `${count} available` : "Made to order"}
                className="group relative aspect-square rounded-sm border border-border bg-[hsl(var(--background))] hover:border-[hsl(var(--primary))] hover:shadow-[0_12px_30px_-20px_rgba(0,0,0,0.3)] transition-all overflow-hidden"
              >
                <div className="h-full w-full flex flex-col items-center justify-center gap-1 p-3">
                  <div className="font-serif text-3xl lg:text-4xl text-foreground group-hover:text-[hsl(var(--primary))] transition-colors">
                    {l.label}
                  </div>
                  <div className="text-[10px] uppercase tracking-widest text-muted-foreground">
                    {l.sub}
                  </div>
                  <div className="text-[10px] text-[#B8935F] mt-1">
                    {inStock ? `${count} piece${count > 1 ? "s" : ""}` : "Made to order"}
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ShopByLength;
